// The visitor's arm (0-based) in an A/B test of `arms` arms, as written on the
// root element by the inline script in `src/app.html` before the first paint.
// Falls back to the first arm when the attribute is missing (no script run,
// or a server render), which is also the arm the CSS shows in that case.
export const getDropAbArm = (arms: number): number => {
	if (typeof document === 'undefined' || arms < 2) {
		return 0;
	}

	const arm = Number(document.documentElement.getAttribute(`data-ab-${arms}`));

	return Number.isInteger(arm) && arm >= 0 && arm < arms ? arm : 0;
};
